import {config} from './apiConfig'
import axios from "axios";

export const user = {
    uid: "",
    token: "",
    name: "",
    email: "",
    permissions: [],
    init (currentUser, cb) {
        this.uid = currentUser.uid;
        var that = this;
        this.fetchToken(currentUser, () => {
            that.fetchData(cb);
        });
    },
    setUid (uid) {
        this.uid = uid;
    },
    setToken (token) {
        this.token = token;
    },
    fetchToken (currentUser, cb) {
        var that = this;
        currentUser.getIdToken(false).then(
            function (token) {
                that.setToken(token);
                if (cb) cb();
            }
        );
    },
    fetchData (cb) {
        axios({ 
            "method": "GET", 
            "url": config.apiUrl + "/user/" + this.uid, 
            "headers": { "content-type": "application/json", "X-Auth": this.token } }
        ).then(result => {
                this.name = result.data.name;
                this.email = result.data.email;
                this.setPermissions(result.data.profile);
                if (cb) cb();
            }, error => {
                console.error(error);
                alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
            }
        );
    },
    setPermissions (permissions) {
        if (permissions) {
            this.permissions = permissions;
        }
    },
    hasPermission (p) {
        return this.permissions[p];
    }
};


// WEBPACK FOOTER //
// ./src/helpers/user.js